import {socket, host, config} from './webRTC';
import { apiFetch } from './httpClient';
import fronLogger from "./logger";

let kurentoUtils = require('./wrapper-kurento-dev');

const setStateVideoCallbacks = {
    STATE_WEBCAM: null,
    STATE_WINDOW: null
};

// variables
let roomName; // внутри функций roomName -- undefine
let userName;
const participants = {};
const typeOfCall = {};
const peers = {};
const peerMessageHandlers = {};
let peerGeneration = 0;

let file_location = "proctoring/frontend/src/libs/kurento.js";

function disposePeers() {
    peerGeneration++;
    for (const type of ['webcam', 'window']) {
        if (peerMessageHandlers[type]) socket.off('kurento message', peerMessageHandlers[type]);
        delete peerMessageHandlers[type];
        if (peers[type]) peers[type].dispose();
        delete peers[type];
    }
}

export function leaveSession() {
    try { disposePeers(); } finally { socket.close(); }
}

export async function stopRoom(token, processRecording = true){
    fronLogger(token, "function [stopRoom] enter", "info", file_location);
    let webcamPresence = peers["webcam"] && peers["webcam"].getLocalSessionDescriptor();
    if(webcamPresence){
        console.log(peers["webcam"].getLocalSessionDescriptor().sdp);
    }
    const finalized = new Promise(resolve => {
        // Allow the bounded metadata remux of both closed recordings to finish.
        const timer = setTimeout(() => resolve({ success: false }), 25 * 60 * 1000);
        socket.emit('stopSome', { token, processRecording }, result => {
            clearTimeout(timer);
            resolve(result || { success: false });
        });
    });
    disposePeers();
    const result = await finalized;
    // The backend queues processing after finalization, including disconnects.
    console.log("send token: ", token, " to celery after recording");
    fronLogger(token, `send token ${token} to celery after recording`, "info", file_location);
    let message = {
        event: 'stopSession',
        roomName: token
    };
    sendMessage(message);
    fronLogger(token, "function [stopRoom] exit", "info", file_location);
    return result;
}


export function joinRoom(username, roomname, type="webcam", setReadyState, setStateProgress, expectedSources = ['webcam', 'window']){
    const generation = peerGeneration;
    if (!socket.connected) socket.connect();
    function onIceCandidate(candidate){
        let message = {
            event: 'backendIceCandidate',
            roomName: roomname,
            type,
            candidate: candidate
        };
        fronLogger(roomname, `joinRoom [onIceCandidate] ${message}`, 'ok', file_location, type);
        console.log('Candidate from frontend to backend: ', candidate);
        socket.emit('kurento message', message);
    }
    let options = {
        sendSource: type,
        oncandidategatheringdone: () => {
            if (generation !== peerGeneration) return;
            if (type === "webcam") {
                joinRoom(username,roomname, "window", setReadyState, setStateProgress, expectedSources);
            }
        },
        roomName: roomname,
        configuration: config,
        onicecandidate: onIceCandidate
    }
    fronLogger(roomname, `joinRoom ${type}`, 'ok', file_location, type);
    let webRtcPeer = kurentoUtils.WebRtcPeer.WebRtcPeerSendonly(options, function(error)
    {
        if (generation !== peerGeneration) { this.dispose(); return; }
        if(error){
            if(error === "withoutWebAndMic"){
                apiFetch(`${host}/webcam/` + roomname, { method: 'POST'})
                    .then(() => { if (generation === peerGeneration) joinRoom(username,roomname, 'window', setReadyState, setStateProgress, ['window']); })
                    .catch(error => fronLogger(roomname, error.message, 'error', file_location));
                fronLogger(roomname, `The user wants to continue without a microphone or webcam.`, "warning", file_location, type);
            }
            fronLogger(roomname, `Some error: ${error}`, "error", file_location);
            return error;
        }
        this.generateOffer(onOffer);
    });
    peers[type] = webRtcPeer;

    function onOffer(error, offer) {
        if (generation !== peerGeneration) return;
        if (error) {
            return error;
        }
    
        let message = {
            userName: username,
            roomName: roomname,
            type: type,
            event: 'receiveVideoFrom',
            sdpOffer: offer,
            expectedSources
        };
        sendMessage(message);
    }

    if (peerMessageHandlers[type]) socket.off('kurento message', peerMessageHandlers[type]);
    const onPeerMessage = message => {
        if (!message || message.roomName !== roomname || message.type !== type) return;
        console.info(`%cKurento message from kurento.js: `, "color: blue");
        console.dir(message);
        // console.dir(message.result);
        // fronLogger(roomname, ` = ${message.result.sessionId}`, "65656565", "kurento.js"); <--- вызывает ошибки
        switch (message.event) {
            case "getSdpAnswer":
                let sdpAnswer = message.sdpAnswer;
                webRtcPeer.processAnswer(sdpAnswer);
                break;
            case "frontIceCandidate":
                let candidate = message.candidate;
                // fronLogger(roomname, `Candidate from backend:  ${candidate.candidate}`, 'ok', file_location, type);
                webRtcPeer.addIceCandidate(candidate, err => {
                    if (err){
                        // console.log('was error in add ice candidate');
                        // fronLogger(roomname, `was error in add ice candidate`, "error", file_location);
                        // console.log('ERROR', err, ' - Candidate: ', candidate);
                        // fronLogger(roomname, `ERROR=${err}, Candidate=${candidate} `, "error", file_location);
                    }
                });
                break;
            case "stopSession":
                // Этот кейс вообще не вызывается
                fronLogger(roomname, `stopSession from Kurento`, "???", file_location);
                // stopSession(message.roomName); no
                break;
            default:
                //fronLogger(roomname, `default case`, "error", file_location);     // it's just spam
                break;
        }
    };
    peerMessageHandlers[type] = onPeerMessage;
    socket.on('kurento message', onPeerMessage);
}

window.onload = function() {
    let videoScreen = document.getElementById('videoInput');
    let videoWebCamera = document.getElementById('videoOutput');
    typeOfCall["webcam"] = videoWebCamera;
    typeOfCall["window"] = videoScreen;
}

socket.on('kurento message', message => {
    console.log('%cKurento message from frontend/libs/kurento.js: ', 'color: blue');
    console.dir(message);
    switch (message.event) {
        case 'newParticipantArrived':
            fronLogger(message.roomName, `newParticipantArrived`, "info", file_location);
            receiveVideo(message.userid, message.username, message.type);
            break;
        case 'existingParticipants':
            fronLogger(message.roomName, `existingParticipants`, "info", file_location);
            onExistingParticipants(message.userid, message.existingUsers);
            break;
        case 'receiveVideoAnswer':
            fronLogger(message.roomName, `receiveVideoAnswer`, "info", file_location);
            onReceiveVideoAnswer(message.senderid, message.sdpAnswer);
            break;
        case 'candidate':
            fronLogger(message.roomName, `candidate`, "info", file_location);
            addIceCandidate(message.userid, message.candidate);
            break;
        case 'stopSession':
            fronLogger(message.roomName, `stopSession`, "info", file_location);
            stopSession(message.roomName);
            break;
        default:
            //fronLogger(message.roomName, `default case`, "error", file_location);     // it's just spam
            break;
    }
});

// в этой функции не получится сделать логи
function receiveVideo(userid, username, type) {
    let user = {
        id: userid,
        username: username,
        rtcPeer: null
    };
    participants[user.id] = user;
    
    let video = typeOfCall[type];
    let options = {
        remoteVideo: video, //videoWebCamera,
        sendSource: type,
        onicecandidate: onIceCandidate,
        stateChange: setStateVideoCallbacks[type]
    };

    console.log('RECEIVE VIDEO ', userid, username);

    // fronLogger(userid, "RECEIVE VIDEO _ 1", "ok", file_location);  // <- это лог не выводится, потому что мапинг по токену команты 

    user.rtcPeer = kurentoUtils.WebRtcPeer.WebRtcPeerSendonly(options,
        function (err) {
            if (err) {
                return err;
            }
            this.generateOffer(onOffer);
        }
    );

    let onOffer = function (err, offer, wp) {
        let message = {
            event: 'receiveVideoFrom',
            userid: user.id,
            roomName: roomName,
            sdpOffer: offer
        };
        sendMessage(message);
    }

    function onIceCandidate(candidate, wp) {
        let message = {
            event: 'candidate',
            userid: user.id,
            roomName: roomName,
            candidate: candidate
        };
        sendMessage(message);
    }
}

function onExistingParticipants(userid, existingUsers) {
    let user = {
        id: userid,
        username: userName,
        video: typeOfCall["webcam"],
        rtcPeer: null
    };

    participants[user.id] = user;
    let video = typeOfCall["webcam"];
    let options = {
        remoteVideo: video, //videoWebCamera,
        sendSource: "webcam",
        onicecandidate: onIceCandidate,
        stateChange: setStateVideoCallbacks["webcam"]
    };
    fronLogger(userid, "used kurentoUtils.WebRtcPeer.WebRtcPeerSendonly(options, errorFunc);", "error", file_location); // лог этот не работает -- у нас маппинг логов по id комнаты 
    user.rtcPeer = kurentoUtils.WebRtcPeer.WebRtcPeerSendonly(options,
        function (err) {
            if (err) {
                return err;
            }
            this.generateOffer(onOffer)
        }
    );

    existingUsers.forEach(function (element) {
        receiveVideo(element.id, element.name);
    });

    let onOffer = function (err, offer, wp) {
        let message = {
            event: 'receiveVideoFrom',
            userid: user.id,
            roomName: roomName,
            sdpOffer: offer
        };
        sendMessage(message);
    };

    function onIceCandidate(candidate, wp) {
        let message = {
            event: 'candidate',
            userid: user.id,
            roomName: roomName,
            candidate: candidate
        };
        sendMessage(message);
    }
}

function onReceiveVideoAnswer(senderid, sdpAnswer) {
    participants[senderid].rtcPeer.processAnswer(sdpAnswer);
}

function addIceCandidate(userid, candidate) {
    participants[userid].rtcPeer.addIceCandidate(candidate);
}

export function stopSession(token, processRecording = true) {
    document.querySelector("link[rel='icon']").href = "/logo.png";
    return stopRoom(token, processRecording);
}

function sendMessage(message) {
    console.log('sending ' + message.event + ' message to server');
    socket.emit('kurento message', message);
}
